//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.PostConfigurator.js";
import "../no/Builder.js";
import "../SIM/SIM.PostConfigurator.UdeBuilderList.js";
import "../no/SIM.js";
import "../no/ObjectList.js";
let d=[[[1,"UdeBuilderList",0,"SIM.PostConfigurator.UdeBuilderList",0]],[[["eventHandlerID"],"GetUdeBuilder",{R_:{udeBuilder:"SIM.PostConfigurator.UdeBuilder"}},1,0],[[],"AddNewEvent",{R_:{udeBuilder:"SIM.PostConfigurator.UdeBuilder"}},0,0],[["udeBuilder"],"DuplicateEvent",{R_:{newUdeBuilder:"SIM.PostConfigurator.UdeBuilder"}},1,0],[["udeBuilder"],"RemoveEvent",{},1,0],[["udeBuilder"],"ListEvent",{},1,0],[["eventID","cdlFile"],"GetUdeBuilderByCdl",{R_:{udeBuilder:"SIM.PostConfigurator.UdeBuilder"}},2,0],[["udeBuilder","cdlFile"],"CopyEventToCdlFile",{R_:{newUdeBuilder:"SIM.PostConfigurator.UdeBuilder"}},2,0],[["udeBuilder"],"AddUdeHandler",{},1,0],[["udeBuilder"],"RemoveUdeHandler",{},1,0],[[],"ReloadUDEAndUDC",{},0,0]],[]];
SPLM.SIM.PostConfigurator.UdeEditorBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.PostConfigurator.UdeEditorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;